module.exports = __webpack_public_path__ + "img/pods-movim.png";